module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/configurations/table-configuration/table-configuration.component.css
// module id = ./src/app/components/configurations/table-configuration/table-configuration.component.css
// module chunks = main